import type { IntegrationConfig } from './types';
import { BaseIntegration } from './core/BaseIntegration';

/**
 * Integration constructor type
 */
export type IntegrationConstructor = new (
  config: IntegrationConfig,
) => BaseIntegration;

/**
 * Integration registry (populated as integrations are imported)
 */
export const INTEGRATION_REGISTRY: Record<string, IntegrationConstructor> = {};

/**
 * Register an integration
 */
export function registerIntegration(
  name: string,
  constructor: IntegrationConstructor,
): void {
  INTEGRATION_REGISTRY[name] = constructor;
}

/**
 * Get integration constructor by name
 */
export function getIntegration(
  name: string,
): IntegrationConstructor | undefined {
  return INTEGRATION_REGISTRY[name];
}

/**
 * Check if integration is known
 */
export function isKnownIntegration(name: string): boolean {
  return name in INTEGRATION_REGISTRY;
}

/**
 * Get all registered integration names
 */
export function getRegisteredIntegrations(): string[] {
  return Object.keys(INTEGRATION_REGISTRY);
}
